"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricksUtils = require("@titelmedia/bricks-utils");
var _bricksProgressBar = require("@titelmedia/bricks-progress-bar");
var _bricks = require("./bricks.js");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StoryLayout = (0, _react.forwardRef)(({
  children,
  progressBar
}, ref) => {
  const [size, setSize] = (0, _react.useState)({
    width: 0,
    height: 0
  });
  (0, _react.useEffect)(() => {
    if (typeof window !== 'undefined' && ref.current) {
      const resizeObserver = new ResizeObserver(entries => {
        setSize({
          width: entries[0].contentRect.width,
          height: entries[0].contentRect.height
        });
      });
      resizeObserver.observe(ref.current);
      return () => {
        resizeObserver?.disconnect();
      };
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (_bricksUtils.ScrollTrigger.getAll().length > 0) {
      _bricksUtils.ScrollTrigger.refresh(true);
    }
  }, [size]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    id: "bricks-container"
  }, _react.default.createElement("div", {
    id: _bricks.CONTAINER_ID,
    ref: ref
  }, children)), progressBar && _react.default.createElement(_bricksProgressBar.ProgressBar, progressBar.data));
});
var _default = StoryLayout;
exports.default = _default;
//# sourceMappingURL=Layout.js.map